<template>
  <div class="common-loading" :class="{ compact }">
    <span class="loading-ring"></span>
    <span class="loading-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'CommonLoading',
  props: {
    text: {
      type: String,
      default: '加载中'
    },
    compact: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.common-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 14px;
  min-height: 180px;
  color: rgba(255, 255, 255, 0.72);
  text-align: center;
}

.common-loading.compact {
  min-height: 96px;
  gap: 10px;
}

.loading-ring {
  position: relative;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, rgba(0, 141, 255, 0), rgba(0, 141, 255, 0.95), rgba(255, 255, 255, 0.95), rgba(0, 141, 255, 0));
  animation: loadingRotate 0.9s linear infinite;
}

.loading-ring::before {
  content: '';
  position: absolute;
  inset: 4px;
  border-radius: 50%;
  background: var(--loading-bg, #0b0d10);
}

.loading-ring::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 14px rgba(255, 255, 255, 0.75);
  transform: translateX(-50%);
}

.loading-text {
  font-size: 14px;
  letter-spacing: 0;
}

@keyframes loadingRotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
